// Legal disclaimer — required on every screen.

import { LEGAL_FOOTER } from "../config/constants";

export function mountFooter(): void {
  const el = document.getElementById("legal-footer");
  if (!el) throw new Error("legal-footer element missing from index.html");
  el.textContent = LEGAL_FOOTER;
}
